import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCampaigns = lazy(() => import("@/pages/admin/AdminCampaigns"));

export const Route = createFileRoute("/admin/campaigns")({
  component: AdminCampaigns,
});
